// Centralisation de l'URL de base API pour éviter les duplications entre store et client HTTP.

export const getApiBaseUrl = (): string => {
  // Si VITE_API_BASE_URL est défini (env var), l'utiliser.
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  // En production, utiliser le même domaine avec /api.
  // En développement, conserver aussi une URL relative pour supporter le LAN
  // via le proxy Vite sans dépendre d'un localhost côté client.
  if (import.meta.env.DEV) {
    return "/api";
  }

  return "/api";
};

export const API_BASE_URL = getApiBaseUrl();
